export default __webpack_public_path__ + "10a4b25c15576627394d73ca5f45372a.png";